module.exports = __webpack_public_path__ + "static/media/UofT.c05cfa3b.svg";